import React, { useEffect, useRef } from "react";

const ResponsiveImage = ({
  src,
  alt,
  className,
  style = {},
  boxShadow = false,
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const img = new Image();
    img.src = src;

    // We only trigger image load, but since we are not using the aspect ratio state anymore,
    // we can remove the ResizeObserver logic completely to fix the undefined 'setDimensions'.
  }, [src]);

  const imageStyle = {
    width: "100%",
    height: "auto",
    ...style, // Kombiniert bestehende Styles mit den neuen
  };

  if (boxShadow) {
    imageStyle.boxShadow = "5px 10px 20px rgba(0, 0, 0, 0.5)";
  }

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      <img src={src} alt={alt} className={className} style={imageStyle} />
    </div>
  );
};

export default ResponsiveImage;
